<fieldset role="alert" *ngIf="content && variant === 'classic'" class="info-box" [ngClass]="{
    bordered: bordered,
    'max-width-limited': maxWidthLimited,
    'color-info': type === 'info',
    'color-warning': type === 'warning',
    'color-error': type === 'error',
    'color-success': type === 'success',
    monochrome: iconStyle === 'monochrome',
    blue: iconStyle === 'blue'
  }" [style.width.%]="width">
  <legend class="info-box__warning" *ngIf="bordered">
    {{ infoBoxTitle }}
  </legend>
  <p class="info-box__text" appInternalLink [innerHTML]="infoBoxText"></p>
</fieldset>

<div role="alert" *ngIf="variant === 'modern'" class="info-box-modern" [ngClass]="'info-box-modern--' + type"
  [class.max-width-limited]="maxWidthLimited" [style.width.%]="width">

  <div class="info-box-modern__icon-wrapper">
    <svg *ngIf="type === 'info'" width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#2434B3" />
      <g clip-path="url(#clip0_21319_44666)">
        <path
          d="M9.9974 15.8332C13.2191 15.8332 15.8307 13.2215 15.8307 9.99984C15.8307 6.77818 13.2191 4.1665 9.9974 4.1665C6.77573 4.1665 4.16406 6.77818 4.16406 9.99984C4.16406 13.2215 6.77573 15.8332 9.9974 15.8332Z"
          stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 12.3333V10" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 7.6665H10.0058" stroke="white" stroke-width="1.16667" stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_21319_44666">
          <rect width="14" height="14" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>

    <svg *ngIf="type === 'warning'" width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#E8A317" />
      <path
        d="M15.6759 13.4998L11.0092 5.33314C10.9075 5.15359 10.7599 5.00425 10.5816 4.90035C10.4033 4.79644 10.2006 4.7417 9.99425 4.7417C9.78787 4.7417 9.58519 4.79644 9.40688 4.90035C9.22856 5.00425 9.081 5.15359 8.97925 5.33314L4.31258 13.4998C4.20973 13.6779 4.1558 13.8801 4.15625 14.0858C4.15671 14.2915 4.21153 14.4934 4.31517 14.671C4.41881 14.8487 4.56758 14.9958 4.7464 15.0975C4.92522 15.1991 5.12774 15.2517 5.33341 15.2498H14.6667C14.8714 15.2496 15.0725 15.1955 15.2497 15.0931C15.4269 14.9906 15.574 14.8433 15.6762 14.666C15.7785 14.4886 15.8323 14.2875 15.8322 14.0828C15.8322 13.8781 15.7783 13.6771 15.6759 13.4998Z"
        stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10 8.25V10.5833" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10 12.9165H10.0058" stroke="white" stroke-width="1.16667" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    <svg *ngIf="type === 'error'" width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#FF0000" />
      <g clip-path="url(#clip0_21319_44545)">
        <path
          d="M14.6693 10.5834C14.6693 13.5001 12.6276 14.9584 10.2009 15.8043C10.0739 15.8473 9.93583 15.8453 9.8101 15.7984C7.3776 14.9584 5.33594 13.5001 5.33594 10.5834V6.5001C5.33594 6.34539 5.3974 6.19702 5.50679 6.08762C5.61619 5.97822 5.76456 5.91677 5.91927 5.91677C7.08594 5.91677 8.54427 5.21677 9.55927 4.3301C9.68285 4.22452 9.84006 4.1665 10.0026 4.1665C10.1651 4.1665 10.3224 4.22452 10.4459 4.3301C11.4668 5.2226 12.9193 5.91677 14.0859 5.91677C14.2406 5.91677 14.389 5.97822 14.4984 6.08762C14.6078 6.19702 14.6693 6.34539 14.6693 6.5001V10.5834Z"
          stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 7.6665V9.99984" stroke="white" stroke-width="1.16667" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M10 12.3335H10.0058" stroke="white" stroke-width="1.16667" stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_21319_44545">
          <rect width="14" height="14" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>

    <svg *ngIf="type === 'success'" width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#0EA55A" />
      <g clip-path="url(#clip0_21319_44638)">
        <path
          d="M11.75 11.1665C11.8667 10.5832 12.1583 10.1748 12.625 9.70817C13.2083 9.18317 13.5 8.42484 13.5 7.6665C13.5 6.73825 13.1313 5.84801 12.4749 5.19163C11.8185 4.53525 10.9283 4.1665 10 4.1665C9.07174 4.1665 8.1815 4.53525 7.52513 5.19163C6.86875 5.84801 6.5 6.73825 6.5 7.6665C6.5 8.24984 6.61667 8.94984 7.375 9.70817C7.78333 10.1165 8.13333 10.5832 8.25 11.1665"
          stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8.25 13.5H11.75" stroke="white" stroke-width="1.16667" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M8.83594 15.8335H11.1693" stroke="white" stroke-width="1.16667" stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_21319_44638">
          <rect width="14" height="14" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  </div>

  <div class="info-box-modern__content" appInternalLink [innerHTML]="infoBoxText"></div>
</div>